import {combineReducers} from 'redux';
import initSaga from '../sagas/initSaga';
import reservationSaga from '../sagas/reservationSaga';
import organizationSaga from '../sagas/organizationSaga';
import I18nSaga from '@wix/restaurants-redux/dist/sagas/I18nSaga';

export default combineReducers({
  init: initSaga.reducer,
  reservation: reservationSaga.reducer,
  organization: organizationSaga.reducer,
  i18nData: I18nSaga.reducer
});



// WEBPACK FOOTER //
// ./reducers/index.js